import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.css']
})
export class CookiePolicyComponent {}
